import { getAuthLiteHeaders } from 'services/AuthServices.web';
import { Action } from 'modules/types/common';
import { RootDispatch, RootState } from 'store/types';
import { PatchEventBody } from './types';
import { PATCH_EVENT } from './actions.common';

export * from './actions.common';

export const patchAuthLiteEventBySourceId = (sourceId: string, body: PatchEventBody) => (
  dispatch: RootDispatch,
  getStore: () => RootState
): Action => {
  const headers = getAuthLiteHeaders(getStore());
  return dispatch({
    type: PATCH_EVENT,
    payload: {
      client: 'events',
      request: {
        headers,
        method: 'patch',
        url: `/al/events-by-source/${sourceId}`,
        data: body
      }
    }
  });
};
